import React from 'react';
import { Activity, Stethoscope, Bed, AlertCircle } from 'lucide-react';

export const HospitalRehabModule: React.FC = () => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-red-100 text-red-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Epic Rehab & Cerner Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Rehabilitation Hospital Patient Care</h2>
          <p className="text-xs text-slate-500">Inpatient bed management, multidisciplinary rounds log, and discharge planning</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
            <Bed className="w-4 h-4 text-red-600" />
            Ward Bed Occupancy
          </h3>
          <div className="space-y-2 text-xs">
            <div className="p-2.5 bg-white border rounded-lg flex justify-between items-center">
              <div>
                <div className="font-bold text-slate-900">Bed 302A - Pediatric Rehab</div>
                <div className="text-[10px] text-slate-500">Post-Op Physical Therapy</div>
              </div>
              <span className="px-2 py-0.5 bg-red-100 text-red-800 text-[10px] font-bold rounded">Occupied</span>
            </div>
          </div>
        </div>

        <div className="md:col-span-2 p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
            <Activity className="w-4 h-4 text-red-600" />
            Multidisciplinary Clinical Care Rounds
          </h3>
          <div className="bg-white p-4 rounded-lg border border-slate-200 text-xs space-y-2">
            <div className="flex justify-between font-bold">
              <span className="text-slate-900">Patient: Master Rahul S. (Age 10)</span>
              <span className="text-emerald-600">Discharge Readiness: 82%</span>
            </div>
            <p className="text-slate-600">Physiatrist, Speech Pathologist, and OT agreed on gait training milestones for home transition.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
